import toposort from "toposort";
import { CyclicalDependencyError } from "../errors";
const TOPO_SORT_ERROR_MESSAGE = "Cyclic dependency, node was:";
export function runToposort(edges) {
    try {
        return toposort(edges);
    }
    catch (ex) {
        if (ex instanceof Error && ex.message.startsWith(TOPO_SORT_ERROR_MESSAGE)) {
            let node;
            try {
                node = JSON.parse(ex.message.slice(TOPO_SORT_ERROR_MESSAGE.length));
            }
            catch (ex2) {
                throw ex;
            }
            throw new CyclicalDependencyError(ex.message, node.name || node.type || "", node.termName, node.iterableName);
        }
        throw ex;
    }
}
//# sourceMappingURL=run-toposort.js.map